import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { CustomValidators } from 'src/app/services/error-message/custom-validators';
import { SharedService } from 'src/app/services/shared.service';
import { FilterModel } from '../../common-models/common.model';
import { CommonService } from '../common.service';

@Component({
  selector: 'app-view-logs',
  templateUrl: './view-logs.component.html',
  styleUrls: ['./view-logs.component.scss']
})
export class ViewLogsComponent implements OnInit {
  dataList: any = [];
  pageSettings: PageSettingsModel;
  isFromUser = false;
  dataModel = new FilterModel();
  customFilter = '';
  filterSettings: any;
  @ViewChild('gridViewProfileLog')
  public grid: GridComponent;

  constructor(
    private dialogRef: MatDialogRef<ViewLogsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private commonService: CommonService,
    public sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    this.pageSettings = this.sharedService.resetPageSettings();
    this.getData();
    this.filterSettings = { filterOperators: ['contains'] };
  }

  getData() { 
    if (this.data.apiName == 'getCompoundLogs' || this.data.apiName == 'getProfileLogs' || this.data.apiName == 'getProfileLogsList') {
      this.commonService[this.data.apiName](this.data.id).subscribe(res => {
        if (res) {
          res.forEach(m => {
            m.viewCreatedDateTime = CustomValidators.DateTimeConvert(m.createdDateTime);
          });
          this.dataList = res;
        }
      });
    }

    if (this.data.apiName == 'getReagentInfoLogs' || this.data.apiName == 'getChemicalCompoundLogs' || this.data.apiName == 'getEquipmentLogs') {
      this.commonService[this.data.apiName](this.data.id).subscribe(res => {
        if (res && res.data && res.data.length > 0) {
          res.data.forEach(m => {
            m.viewCreatedDateTime = CustomValidators.DateTimeConvert(m.createdDateTime);
          });
          this.dataList = res.data;
        }
      });
    }
    

    if (this.data.apiName == 'userAcitivityLog' || this.data.apiName == 'userProfileAcitivityLog') {
      this.isFromUser = true;
      this.sharedService.getEjsGridData(this.commonService[this.data.apiName](this.data.id, this.dataModel, this.customFilter)).subscribe(data => {
        this.dataList = data;
      });
    }

    if (this.data.apiName == 'getRoleAcitivityLog' || this.data.apiName == 'getTestCodeLogs') {
        this.isFromUser = true;
      this.sharedService.getEjsGridData(this.commonService[this.data.apiName](this.data.id, this.dataModel, this.customFilter)).subscribe(data => {
        this.dataList = data;
      });
    }
  }

  dataStateChange(state) {
    this.sharedService.dataStateChange(state, this.dataModel).then(res => {
      this.dataModel.PageSize = res.dataModel.PageSize;
      this.dataModel.StartPageNo = res.dataModel.StartPageNo;
      this.dataModel.SortExpression = res.dataModel.SortExpression;
      if (res.pageSettings) {
        this.pageSettings = res.pageSettings;
      }
      this.customFilter = this.sharedService.setCustomFilter(state);
      this.getData();
    });
  }

  cancelClick(): void {
    this.dialogRef.close();
  }

  dataBound() {
    Object.assign((this.grid.filterModule as any).filterOperators, { startsWith: 'contains' });
  }
}
